import {useCallback} from 'react';

import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';
import {TrackingEvent} from '@/services';

export const useLinkExpiredTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewLinkExpired = useCallback(
    (eventName: TrackingEvent, data?: Record<string, any>) => {
      trackEvent(eventName, {
        project_tag: PROJECT_TAGS.PASSWORD,
        metadata: {
          ...data,
        },
      });
    },
    [trackEvent],
  );

  return {
    trackViewLinkExpired,
  };
};
